import { createContext } from "react"
import { JsonServiceClient } from '@servicestack/client';
import DefaultClient from "@/apis/DefaultClient";

export const ServiceStackClientContext = createContext<JsonServiceClient>(DefaultClient());

export default ServiceStackClientContext;